import React from 'react';
import PropTypes from 'prop-types';
import SmallAreaChart from 'common/dashboards/_components/SmallAreaChart';

import { staticStyles } from './style';

const SmallAreaCharts = ({ currentMonthFunnel, lastMonthFunnel, dailyFunnels, tomorrow }) => {
  const registered = [];
  let registeredAcc = 0;
  const realUsers = [];
  let realUsersAcc = 0;
  const demoUsers = [];
  let demoUsersAcc = 0;
  const ftd = [];
  let ftdAcc = 0;
  const days = [];
  let isRealData = true;
  Object.entries(dailyFunnels).forEach(([key, value]) => {
    if (key === tomorrow) {
      isRealData = false;
    }
    if (isRealData) {
      days.push(key);
      registeredAcc = value.joined_users + registeredAcc;
      registered.push(registeredAcc);
      realUsersAcc = value.users_created_real_account + realUsersAcc;
      realUsers.push(realUsersAcc);
      demoUsersAcc = value.users_created_demo_account + demoUsersAcc;
      demoUsers.push(demoUsersAcc);
      ftdAcc = value.deposited_users + ftdAcc;
      ftd.push(ftdAcc);
    }
  });
  const {
    joined_users: currentRegistered = 0,
    users_created_real_account: currentRealUsers = 0,
    users_created_demo_account: currentDemoUsers = 0,
    deposited_users: currentFtd = 0,
  } = currentMonthFunnel || {};
  const {
    joined_users: lastMonthRegistered = 0,
    users_created_real_account: lastMonthRealUsers = 0,
    users_created_demo_account: lastMonthDemoUsers = 0,
    deposited_users: lastMonthFtd = 0,
  } = lastMonthFunnel || {};

  return (
    <div className="SmallAreaCharts">
      <SmallAreaChart
        color="#43B6E8"
        captionId="Registered"
        amountLastMonth={lastMonthRegistered}
        amountNow={currentRegistered}
        categoriesData={days}
        seriesData={registered}
      />
      <SmallAreaChart
        color="#F5A623"
        captionId="boDemoAccount"
        amountLastMonth={lastMonthDemoUsers}
        amountNow={currentDemoUsers}
        categoriesData={days}
        seriesData={demoUsers}
      />
      <SmallAreaChart
        color="#6AC347"
        captionId="boLiveAccount"
        amountLastMonth={lastMonthRealUsers}
        amountNow={currentRealUsers}
        categoriesData={days}
        seriesData={realUsers}
      />
      <SmallAreaChart
        color="#39DBD3"
        captionId="boFTD"
        amountLastMonth={lastMonthFtd}
        amountNow={currentFtd}
        categoriesData={days}
        seriesData={ftd}
      />

      <style jsx>{staticStyles}</style>
    </div>
  );
};

SmallAreaCharts.propTypes = {
  currentMonthFunnel: PropTypes.object,
  lastMonthFunnel: PropTypes.object,
  dailyFunnels: PropTypes.object,
  tomorrow: PropTypes.string.isRequired,
};

SmallAreaCharts.defaultProps = {
  currentMonthFunnel: {},
  lastMonthFunnel: {},
  dailyFunnels: {},
};

export default SmallAreaCharts;
export { SmallAreaCharts };
